import angular from 'angular';

import provider from './provider.js';
import community from './community.js';
import relation from './relation.js';

export default 'models';

angular.module('models', [provider, community, relation]);